import { useEffect, useState } from "react";

let cached: boolean | null = null;

/**
 * Probes /mascot/idle.png once. Until a real mascot PNG is dropped in
 * public/mascot/, every mascot surface stays hidden (no empty boxes, no flash).
 */
export const useMascotReady = (): boolean | null => {
  const [ready, setReady] = useState<boolean | null>(cached);

  useEffect(() => {
    if (cached !== null) {
      setReady(cached);
      return;
    }
    const img = new Image();
    img.onload = () => {
      cached = true;
      setReady(true);
    };
    img.onerror = () => {
      cached = false;
      setReady(false);
    };
    img.src = "/mascot/idle.png";
  }, []);

  return ready;
};
